import { toast, arrayUnqiue } from "../../libs/utils"



export default {
  state: {
    reportId: '', // 报告ID
    patientName: '', // 患者姓名
    patientAge: '', // 患者年龄
    ageUnit: '', // 患者年龄单位
    patientGender: '', // 患者性别
    hospitalCenterName: '', // 影像中心
    checkTime: '', // 检查时间
    reportCode: '', // 报告单号
    matchedFilmNo: '', // 影像单号
    checkBody: '', // 检查部位
    bodyNameAndAlias: [], // 检查部位和别名
    imageRepresentation: '', // 影像表现
    diagnosticResult: '', // 影像诊断
    deviceCategoryName: '', // 检查项目
    diseaseList: [], // 病种标签
    positiveNegative: '', // 诊断属性
    writeDoctor: '', // 编写医生
    writeDoctorId: '', // 编写医生的ID
    checkDoctor: '', // 审核医生
    checkDoctorId: '', // 审核医生ID
    status: '', // 报告状态
    dieaseRemark: '', // 病种备注
    overLineFlag: false // 是否超过打印行数
  },
  actions: {
    setReportData ({state}, data) {
      state.patientName = data.patient_name || ''
      state.patientAge = data.age.toString() || ''
      state.ageUnit = data.age_unit || ''
      state.patientGender = data.gender || data.sex? data.sex === 1? '男' : '女' : ''
      state.reportId = data.id || ''
      state.status = data.status || ''
      state.hospitalCenterName = data.hospital_medical_image_center_name || data.hospital_medical_diagnose_center_name || ''
      state.checkTime = data.check_datetime || ''
      state.reportCode = data.report_code || ''
      state.matchedFilmNo = data.matched_film_no || ''
      state.checkBody = data.check_item_name || data.check_item_selected_name || ''
      state.imageRepresentation = data.image_representation || ''
      state.diagnosticResult = data.diagnostic_result || ''
      state.deviceCategoryName = data.device_category_name || ''
      if (data.bodyItems) state.bodyNameAndAlias = data.bodyItems
      if (data.positive_negative.toString() === 'true' || data.positive_negative.toString() === 'false') state.positiveNegative = data.positive_negative
      state.writeDoctor = data.report_write_doctor_name || ''
      state.writeDoctorId = data.report_write_doctor_id
      state.checkDoctor = data.report_review_doctor_name || ''
      state.checkDoctorId = data.report_review_doctor_id || ''
      state.dieaseRemark = data.disease_comment || ''
      if (data.disease_list) {
        state.diseaseList = []
        try {
          let list = JSON.parse(data.disease_list)
          list.forEach(item => {
            state.diseaseList.push({key: `${item.id}|${item.code}`, originKey: item.code, id: item.id, label: item.name})
          })
        } catch (error) {
          toast({msg: '解析疾病标签数异常'})
          console.log(error)
        }
      } else {
        state.diseaseList = []
      }
    },
    // 设置影像表现
    setImageRepresentation ({state}, data) {
      state.imageRepresentation = data
    },
    // 设置影像诊断
    setDiagnosticResult ({state}, data) {
      state.diagnosticResult = data
    },
    // 追加影像表现
    addToImageRepresentation ({state}, data) {
      if (!data) return false
      state.imageRepresentation = state.imageRepresentation + data
    },
    // 追加影像诊断
    addToDiagnosticResult ({state}, data) {
      if (!data) return false
      state.diagnosticResult = state.diagnosticResult + data
    },
    // 设置诊断属性
    setPositiveNegative ({state}, data) {
      state.positiveNegative = data
    },
    // 设置疾病列表
    setDieaseList ({state}, data) {
      state.diseaseList = data
    },
     // 追加疾病列表
    addDieaseList ({state}, data) {
      state.diseaseList.push(...data)
      state.diseaseList = arrayUnqiue(state.diseaseList, 'key') 
    },
    // 设置检查部位
    setCheckBody ({state}, data) {
      state.checkBody = data
    },
    // 设置报告状态
    setReportStatus ({state}, val) {
      state.status = val
    },
    // 设置疾病备注
    setDieaseRemark ({state}, val) {
      state.dieaseRemark = val
    },
    setOverLineFlag ({state}, flag) {
      state.overLineFlag = flag
    }
  }
}